import styled from 'styled-components';

export const StyledDialog = styled.dialog<{
  show?: boolean;
  screenWidth: number;
}>`
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  width: ${(props) =>
    props.screenWidth < 713 ? `${props.screenWidth}px` : '713px'};
  flex: 1 1 auto;
  overflow-y: auto;
  margin: auto;
  /* Match pre–style-reset dialog: horizontal + bottom inset like UA default; top stays 0 (close button margin controls header offset). */
  padding: 0 1em 1em 1em;
  background-color: white;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.body.fontFamily};
  border-radius: 4px;
  box-shadow:
    0px 11px 15px -7px rgb(0 0 0 / 20%),
    0px 24px 38px 3px rgb(0 0 0 / 14%),
    0px 9px 46px 8px rgb(0 0 0 / 12%);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border: none;
  height: min-content;
  min-height: calc(100vh - 140px);
`;
